import helpBubble from 'assets/helpBubble.svg';
import plusImage from 'assets/plus-green.svg';
import {
  AddressCard,
  BackPage,
  BasketPageBar,
  DeliveryOptionCard,
  OrderBar,
  PaymentOptionCard,
  Spinner,
} from 'components';
import { usePostManualOrder } from 'hooks/useManualOrders';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { DeliveryOptionPageContent, ManualBasketPageContent } from 'services/content';
import styles from './styles.module.css';

const ManualBasket = () => {
  const history = useHistory();
  const { manualJourney } = useSelector((state) => state);
  const startedJourney = manualJourney?.started;
  const [placingOrder, setPlacingOrder] = useState(false);
  const postManualOrder = usePostManualOrder();

  useEffect(() => {
    if (!startedJourney) history.push('/pharmacy/dashboard');
  }, [startedJourney, history]);

  const totalCost = manualJourney?.selectedOrder?.total_amount?.toFixed(2);

  const placeOrder = async () => {
    try {
      setPlacingOrder(true);
      const postObject = {
        order_id: manualJourney.selectedOrder.coop_order_id,
        total_amount: {
          main_digits: parseInt(totalCost.split('.')[0]),
          fraction_digits: parseInt(totalCost.split('.')[1]),
          currency_code: 'GBP',
        },
        card_token: manualJourney.payment.token,
      };
      const orderResponse = await postManualOrder(postObject);
      setPlacingOrder(false);
      if (orderResponse?.redirect_url) {
        window.location.href = orderResponse?.redirect_url;
      } else {
        history.push('/pharmacy/dashboard/confirmation');
      }
    } catch (e) {
      setPlacingOrder(false);
      history.push('/pharmacy/error');
    }
  };

  if (placingOrder || !startedJourney) {
    return (
      <>
        <OrderBar currentProgress={1} />
        <div className={styles.loadingScreen}>
          <Spinner />
        </div>
      </>
    );
  }

  return (
    <>
      <OrderBar currentProgress={1} />
      <BackPage onBackClick={() => history.push('/pharmacy/dashboard/manual-order')} bplg="6">
        <h1 className={styles.header}>{ManualBasketPageContent.headingText}</h1>
        {manualJourney.selectedOrder.order_items.length === 0 ? (
          <div>Empty Basket</div>
        ) : (
          <ul className={`${styles.medicationContainer} drop-shadow`}>
            {manualJourney.selectedOrder.order_items.map((medication) => (
              <li className={styles.medicationIndividualContainer} key={medication.course_id}>
                <h3 className={styles.medicationTitle}>{medication.name}</h3>
              </li>
            ))}
          </ul>
        )}
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h3 className={styles.sectionTitle}>{ManualBasketPageContent.deliveryHeader}</h3>
          </div>
          <DeliveryOptionCard data={DeliveryOptionPageContent[manualJourney.selectedOrder.fulfillment.delivery_type]} />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h3 className={styles.sectionTitle}>{ManualBasketPageContent.addressHeader}</h3>
          </div>
          <AddressCard address={manualJourney.selectedOrder.fulfillment.address} />
        </div>
        <div className={styles.section}>
          <div className={styles.helpContainer}>
            <h3>{ManualBasketPageContent.helpHeader}</h3>
            <a
              tabIndex="0"
              href="https://intercom-help.eu/heypharmacist/en"
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.helpLink} ${styles.helpRow}`}>
              <img src={helpBubble} className={styles.helpIcon} alt={`Help and support`} />
              <div>{ManualBasketPageContent.helpText}</div>
            </a>
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h3 className={styles.sectionTitle}>{ManualBasketPageContent.paymentHeader}</h3>
            {Object.keys(manualJourney.payment).length !== 0 && (
              <button
                className={styles.link_button}
                href="#"
                onClick={() => history.push('/pharmacy/dashboard/payment')}>
                Change
              </button>
            )}
          </div>
          {Object.keys(manualJourney.payment).length !== 0 ? (
            <PaymentOptionCard accountView paymentOption={manualJourney.payment} />
          ) : (
            <div className={styles.addPaymentRow} onClick={() => history.push('/pharmacy/dashboard/payment')}>
              <img src={plusImage} className={styles.plusIcon} alt="Add a payment" />
              <p className={styles.addPaymentText}>Add a payment</p>
            </div>
          )}
        </div>
      </BackPage>
      <BasketPageBar
        disabled={Object.keys(manualJourney.payment).length === 0}
        isManual
        isPharmacyCollection={false}
        price={totalCost}
        callBack={() => placeOrder()}
      />
    </>
  );
};

export default ManualBasket;
